import { Epic } from 'interfaces/middleware'
import { filterRequestOfType } from 'rxOperators/filterRequestOfType'
import { CANCEL_ADVISOR_MEETING, cancelAdvisorMeetingActionCreator } from 'components/features/coaching/advisorStore/actions/advisorMeetingActions'
import { mergeMap } from 'rxjs/operators'
import { of, merge } from 'rxjs'
import { CANCEL_MEETING_URL } from 'interfaces/ajax'
import { catchAjaxSafe } from 'rxOperators/catchSafe'
import { killAllFloatingPanesActionCreator } from 'actions/floatingPanesActions'
import { GetMeetingsInfoAction } from 'components/features/coaching/advisorStore/actions/advisorPageActions'

export const cancelMeetingEpic: Epic = (action$, _, { post }) => action$.pipe(
  filterRequestOfType(CANCEL_ADVISOR_MEETING, 'request'),
  mergeMap(({ payload }) => {
    const { params } = payload

    const url = {
      url: CANCEL_MEETING_URL,
      params: {
        uid: params.uid,
      },
    }

    return post(url, { body: {}}).pipe(
      mergeMap(({ response }) => {

        const { advisor, ...restMeeting } = response
        return merge(
          of(cancelAdvisorMeetingActionCreator.success(params, {
            // member: response.member,
            advisor,
            meeting: {
              ...restMeeting,
              advisorUid: advisor.uid,
            },
          })),
          of(new GetMeetingsInfoAction()),
          of(killAllFloatingPanesActionCreator()),
        )
      }),
      catchAjaxSafe((error) => merge(
        of(cancelAdvisorMeetingActionCreator.error(params, error.status, error.xhr.response)),
      ))
    )
  }),
)

